/**
 * "Add to .gitlab-ci.yml" (owner, 2026-11-03): opens Sanctum's CI-wiring MR
 * as the viewer, or answers the one already open. The panel refetches
 * either way, so the setup status then names the MR open (or, after a 409,
 * that CI is already wired).
 */

import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { addCiInclude } from '../api/projectPanel';
import { projectPanelKeys } from './useProjectPanel';
import { writeOptions, type WriteContext } from './panelWrites';
import type { CiIncludeResponse } from '../types/projectPanel.types';

export function useAddCiInclude(
  projectId: string,
): UseMutationResult<CiIncludeResponse, Error, void, WriteContext> {
  const client = useQueryClient();
  const refresh = (): void => {
    void client.invalidateQueries({ queryKey: projectPanelKeys.panel(projectId), exact: true });
  };
  return useMutation({
    ...writeOptions(client, projectId),
    mutationFn: () => addCiInclude(projectId),
    onSuccess: refresh,
    onError: refresh,
  });
}
